<div *ngIf="loading != true" class="container">


  <div style="align-self: center;">
    <h1>{{"Setup Induction Slides" | translate | async}}</h1>
  </div>

  <div class="selection" 
  style="width: 100%;align-items: center;
  justify-content: center;font-size: 20px;
  flex-direction: row;display: flex;height: 60px;padding: 20px;">
    
    <span>{{"Induction Type" | translate | async}} :</span>
      <mat-select style="width: 400px;"
      placeholder="{{'Induction Type' | translate | async}}" 
      (selectionChange)="changeInductionCategory($event.value)"
        [(ngModel)]="selectedCategory">
        <mat-option *ngFor="let category of SetupInductionQuestion?.InductionTypes" [value]="category.ID">
          {{category?.Title}}
        </mat-option>
      </mat-select>
 
  </div>

  <div style="display: flex;flex-direction: row;align-items: center;justify-content: center;">
    <h5 style="margin-top: 10px;margin-bottom: 10px;text-decoration: underline;">Slide images must .png or.jpg format and ideally 600px x 800px</h5>
  </div>

  <div class="listConatiner">
    <mat-list role="list" *ngFor="let section of SetupInductionQuestion?.Selections">
      <mat-list-item role="listitem" style="display: flex;
      flex-direction: column;
      margin-bottom: 20px;margin-top: 20px;">
        
          <div class="CatTitle">
            <span>
              {{section.Title}}
            </span>
          </div>
         

      </mat-list-item>

      <mat-list role="list" *ngFor="let slide of section?.Slides">
        <mat-list-item role="listitem">
          <div class="questionTitleContainer">
            <div style="display: flex;flex:0.5;align-items: center;justify-content: center;">
             
                <i  class="material-icons button__icon" (click)="clickQuestionenableDisable(slide)" *ngIf="slide.Active == false" style="color: red;cursor: pointer;">close</i>
                <i  class="material-icons button__icon" (click)="clickQuestionenableDisable(slide)" *ngIf="slide.Active == true"  style="color: green;cursor: pointer;">done</i>
         
            </div>
            
            <div style="display: flex;flex:1;
            align-items: center;justify-content: left;">
            <span class="SectionTitle">{{slide.Title}}</span>
            </div>

           

            <div style="display: flex;flex:1;align-items: center;justify-content: center;">
            <span style="display: flex;flex-direction: row;">
            
              <i style="cursor: pointer;" (click)="onClickEditSlide(slide)" class="material-icons button__icon">edit</i>
         
            <div style="display: flex;flex-direction: row;margin-left: 20px">
             
                <i style="cursor: pointer;" (click)="SectionDown(slide.SlideSelectionId, slide.Order)" class="material-icons button__icon">keyboard_arrow_down</i>
         
                <i style="cursor: pointer;margin-left: 20px;" (click)="SectionUp(slide.SlideSelectionId,slide.Order)" class="material-icons button__icon">keyboard_arrow_up</i>
              
            </div>
            </span>
          </div>

          </div>
        </mat-list-item>
      </mat-list>

      <div class="addQuestionButton">
        <a class="button button--primary" (click)="openAddSlideDialog(section)"  color="lightgray">
          <i class="material-icons button__icon">add</i>
          <span class="button__text">{{'Add Slide' | translate | async}}</span>
          
        </a>
      </div>

  
  <mat-divider></mat-divider>
  </mat-list>
</div>
</div>

<div *ngIf="loading ==true"
  style="display: flex;flex-direction: column;align-items: center;justify-content: center;min-height: 800px;align-self: center;">
  <mat-spinner></mat-spinner>
</div>